import { DownOutlined } from '@ant-design/icons';
import styled from '@emotion/styled';
import { Avatar, Dropdown, Layout } from 'antd';
import React, { useCallback, useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { PAGES } from '../../../constants/urls/page-urls';
import { SiderContext } from '../../../repository/context/siderContext';
import { UserContext } from '../../../repository/context/userContext';
import { TokenRepository } from '../../../repository/web-storage/token';
import { DropdownHeaderMenu } from '../../molecules/dropdown/DropdownHeaderMenu';

interface HeaderProps {}

export const Header = (props: HeaderProps) => {
  const history = useHistory();
  const userContext = useContext(UserContext);
  const siderContext = useContext(SiderContext);

  const handleDropdownClick = useCallback(({ key }: { key: string }) => {
    if (key === '0') {
      TokenRepository.remove();
      history.push(PAGES.LOGIN);
      // reset context
      userContext.updateUser(null);
      siderContext.updateOpenKey([]);
      siderContext.updateSelectedKey([]);
    }
  }, []);

  return (
    <HeaderStyle className="header">
      <Dropdown overlay={<DropdownHeaderMenu onClickDropDown={handleDropdownClick} />} trigger={['click']}>
        <div
          className="header-dropdown"
          onClick={e => e.preventDefault()}
          role="button"
          tabIndex={0}
          onKeyPress={e => e.preventDefault()}
        >
          <Avatar src={userContext.user?.avatar} />
          <span>
            {userContext.user && `${userContext.user?.firstName || ''} ${userContext.user?.lastName || ''}`.trim()}
          </span>
          <DownOutlined />
        </div>
      </Dropdown>
      {process.env.REACT_APP_STAGE === 'development' && (
        <div className="ribbon ribbon-top-right">
          <span>DEV</span>
        </div>
      )}
      {process.env.REACT_APP_STAGE === 'staging' && (
        <div className="ribbon ribbon-top-right">
          <span>STAGING</span>
        </div>
      )}
    </HeaderStyle>
  );
};

const HeaderStyle = styled(Layout.Header)`
  & > div.header-dropdown {
    float: right;
    font-weight: 600;
    text-align: center;
    width: 160px;
    &:hover {
      background: #19bc9c1a;
    }
  }

  & .ant-avatar {
    width: 40px;
    height: 40px;
    margin: 0 0.5rem 0.5rem 0;
  }

  & .anticon {
    margin-left: 0.5rem;
  }

  /* common */
  .ribbon {
    width: 130px;
    height: 130px;
    overflow: hidden;
    position: absolute;
  }
  .ribbon::before,
  .ribbon::after {
    position: absolute;
    z-index: -1;
    content: '';
    display: block;
    border: 5px solid #2980b9;
  }
  .ribbon span {
    position: absolute;
    display: block;
    width: 250px;
    padding: 15px 0;
    background-color: #00be4b;
    box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
    color: #fff;
    font: 700 18px/1 'Lato', sans-serif;
    text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
    text-transform: uppercase;
    text-align: center;
  }

  /* top right*/
  .ribbon-top-right {
    top: 64px;
    right: 0;
  }
  .ribbon-top-right::before,
  .ribbon-top-right::after {
    border-top-color: transparent;
    border-right-color: transparent;
  }
  .ribbon-top-right::before {
    top: 0;
    left: 0;
  }
  .ribbon-top-right::after {
    bottom: 0;
    right: 0;
  }
  .ribbon-top-right span {
    left: -42px;
    top: 25px;
    transform: rotate(45deg);
  }
`;
